import { mapMyHardwareSnapshot } from "@/services/my-hardware/my-hardware.mapper";
import type {
  MyHardwareDevice,
  MyHardwareService,
  MyHardwareSnapshot,
} from "@/services/my-hardware/my-hardware.types";
import { MyHardwareScenario, resolveScenario } from "./scenarios";

export const SCENARIO_QUERY_PARAM = "scenario";

const wait = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));

const activeScenarioId = (): string =>
  new URLSearchParams(window.location.search).get(SCENARIO_QUERY_PARAM) ?? "";

const applyStatusOverride =
  (scenario: MyHardwareScenario) =>
  (device: MyHardwareDevice): MyHardwareDevice => {
    const status = scenario.statusOverrides[device.assetId];
    if (!status) return device;
    const { nextEligibleDate: _dropped, ...rest } = device;
    return { ...rest, status };
  };

export class MockMyHardwareService implements MyHardwareService {
  public async getMyHardware(): Promise<MyHardwareSnapshot> {
    const scenario = resolveScenario(activeScenarioId());
    await wait(scenario.latencyMs);
    if (scenario.shouldFail) {
      throw new Error(`Simulated my-hardware load failure (scenario: ${scenario.id})`);
    }
    const snapshot = mapMyHardwareSnapshot(scenario.wire);
    return { ...snapshot, devices: snapshot.devices.map(applyStatusOverride(scenario)) };
  }
}
